"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const querystring_1 = require("querystring");
const axios_1 = require("axios");
const errors_1 = require("./errors");
const util_1 = require("./util");
class BaseApiClient {
    constructor(config) {
        if (!config) {
            throw new Error('Must provide the client configuration.');
        }
        const { clientApplicationName, clientApplicationVersion, url, authToken, apiKey, additionalHeaders, httpsAgent, } = config;
        if (!clientApplicationName) {
            throw new Error('Must provide a client application name.');
        }
        if (!url) {
            throw new Error('Must provide an API URL.');
        }
        this.url = url;
        this.defaultHeaders = {
            'X-Api-Client': clientApplicationName,
            ...(!!clientApplicationVersion ? { 'X-Api-Client-Version': clientApplicationVersion } : {}),
            'Content-Type': 'application/json',
            ...(!!authToken ? { Authorization: `Bearer ${authToken}` } : {}),
            ...(!!apiKey ? { 'X-Api-Key': apiKey } : {}),
            ...additionalHeaders,
        };
        this.httpsAgent = httpsAgent;
    }
    isPagination(obj) {
        return Object.keys(obj).every((key) => ['limit', 'offset', 'sort', 'direction'].includes(key));
    }
    mapResponseError({ response, message }) {
        if (response) {
            throw new errors_1.ApiClientResponseError(response.status, response.data, `Received error from API at ${this.url}: ${message} with body ${JSON.stringify(response.data)}`);
        }
        else {
            throw new errors_1.ApiClientUncaughtError(`Error in client when calling API at ${this.url}: ${JSON.stringify(message)}`);
        }
    }
    async get(paramA, paramB = {}, paramC = {}) {
        const path = paramA;
        let filters, pagination;
        // Test whether paramB is filters or pagination
        if (!this.isPagination(paramB) || Object.keys(paramC).length > 0) {
            filters = paramB;
            pagination = pagination = util_1.validatePagination(paramC);
        }
        else {
            pagination = util_1.validatePagination(paramB);
        }
        const url = `${this.url}/${path}${this.formatQuerystring({ ...filters, ...pagination })}`;
        return await this.getAxiosResponse('GET', url);
    }
    async getAllPages(path, filters = {}, pagination = { limit: 100 }) {
        const result = [];
        let getNext = true;
        let offset = pagination.offset || 0; // tslint:disable-line:strict-boolean-expressions
        while (getNext) {
            const page = await this.get(path, filters, { ...pagination, offset });
            result.push(...page);
            offset += pagination.limit;
            if (page.length < pagination.limit) {
                getNext = false;
            }
        }
        return result;
    }
    async post(path, obj) {
        const url = `${this.url}/${path}`;
        return await this.getAxiosResponse('POST', url, obj);
    }
    async put(path, obj) {
        const url = `${this.url}/${path}`;
        return await this.getAxiosResponse('PUT', url, obj);
    }
    async patch(path, obj, filters) {
        const url = `${this.url}/${path}${this.formatQuerystring(filters)}`;
        return await this.getAxiosResponse('PATCH', url, obj);
    }
    async delete(path) {
        const url = `${this.url}/${path}`;
        return await this.getAxiosResponse('DELETE', url);
    }
    async health() {
        const url = `${this.url}/health`;
        return await this.getAxiosResponse('GET', url);
    }
    formatUrl(url) {
        return url.replace(/(https?:\/\/)|(\/){2,}/g, '$1$2');
    }
    formatQuerystring(params = {}) {
        return !!params && Object.keys(params).length > 0 ? `?${querystring_1.stringify(params)}` : '';
    }
    async getAxiosResponse(method, url, data) {
        const config = {
            method,
            url: this.formatUrl(url),
            headers: this.defaultHeaders,
            httpsAgent: this.httpsAgent,
            data,
        };
        try {
            const response = await axios_1.default(config);
            return response.data;
        }
        catch (error) {
            throw this.mapResponseError(error);
        }
    }
}
exports.BaseApiClient = BaseApiClient;



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/common-event-api-client/node_modules/@soluto-private/base-client/dist/src/BaseApiClient.js